import { useTranslation } from "react-i18next";

import IconLgCalculer from "src/core/assets/images/icons/lg-calculer.svg?react";
import IconLgModuler from "src/core/assets/images/icons/lg-moduler.svg?react";
import IconLogoL2DConformite from "src/core/assets/images/icons/logo-l2d-c.svg?react";
import { TabsTrigger } from "src/core/components/ui/tabs";
import { CustomRiskLevel } from "src/core/constants/risk";
import { cn } from "src/core/lib/utils";
import { getRiskClass } from "src/core/utils/riskClass";

type Props = {
  riskTabKey: CustomRiskLevel;
  folderRiskLevel: CustomRiskLevel | undefined;
  isReadOnly: boolean;
};

export const RiskTabTrigger = ({ riskTabKey, folderRiskLevel, isReadOnly }: Props) => {
  const { t } = useTranslation();

  return (
    <TabsTrigger
      value={riskTabKey}
      className="tabs-trigger-folder-cartography"
      disabled={isReadOnly}
    >
      {folderRiskLevel === riskTabKey ? (
        <IconLgCalculer className="w-20 h-20" />
      ) : (
        <IconLgModuler className="w-20 h-20" />
      )}

      <div className="flex flex-col gap-y-5 mt-10 items-center">
        <div className={cn("text-xs font-light", getRiskClass("icon", riskTabKey))}>
          {t(`form.modulerRisk.riskLabel.${riskTabKey.toLowerCase()}Risk`)}
        </div>
        <div
          className={cn(
            "rounded-lg text-gray-xlight text-xs font-light px-15 py-5 w-fit",
            getRiskClass("dot", riskTabKey)
          )}
        >
          {t(`form.modulerRisk.${riskTabKey.toLowerCase()}Risk`)}
        </div>

        {folderRiskLevel === riskTabKey ? (
          <div className="text-xs font-light flex flex-row gap-x-5 items-center justify-center">
            {t("form.modulerRisk.button.calculerParL2D")}
            <IconLogoL2DConformite />
          </div>
        ) : (
          <div className="text-xs font-light">
            {t("form.modulerRisk.button.risqueModulerParUtilisateur")}
          </div>
        )}
      </div>
    </TabsTrigger>
  );
};
